import { render, staticRenderFns } from "./BloodTypeInfo.vue?vue&type=template&id=4e039002&scoped=true&"
import script from "./BloodTypeInfo.vue?vue&type=script&lang=js&"
export * from "./BloodTypeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e039002",
  null
  
)

export default component.exports